import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'spaces',
  size: 'full',
  children: {
    overview: {
      path: 'overview',
      size: 'full',
      children: {
        booking: {
          path: ':workSpaceId/add-booking/:date',
          size: 'full',
        },
      },
    },
    bookings: {
      path: 'bookings',
      size: 'full',
      children: {
        edit: {
          path: ':bookingId/edit',
          size: 'full',
        },
        delete: {
          path: ':bookingId/delete',
          size: 'full',
        },
      },
    },
  },
} as const satisfies Location
